<template>
  <div class="home">
    <div class="first">
      <div class="container">
        <div class="company">
          <h3 class="title">FSK智能光学</h3>
          <div class="content">
            智能光学技术是采用无尘生产，无机矿物涂布，不含金属，不阻隔GPS、ETC和手机信号，并且达到一般市面窗膜前挡所无法达到的高隔热与高透视俱佳的双重效果，是走在世界前沿的全新一代汽车膜
          </div>
          <div class="features-wrap">
            <div class="item">
              <div class="title">强劲隔热</div>
              <div class="desc">全波段热源阻隔 将热量隔绝于车外</div>
            </div>
            <div class="item">
              <div class="title">全防护肤</div>
              <div class="desc">全波段热源阻隔 将热量隔绝于车外</div>
            </div>
            <div class="item">
              <div class="title">信号通畅</div>
              <div class="desc">高分子纳米陶瓷工艺 不阻电子信号 车内畅享网络</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="second">
      <div class="container">
        <div class="products">
          <div class="serise-wrap">
            <div
              class="series"
              :class="{ active: series.id === item.id }"
              v-for="(item, index) in seriesList"
              :key="index"
              @click="seriesClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="data-wrap">
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="version.visible_light"
              ></el-progress>
              <img src="@/assets/visible_light.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.visible_light }}%</div>
                <div class="label">可见光穿透率</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                :width="62"
                color="#45dd7d"
                define-back-color="#102a1f"
                :show-text="false"
                :percentage="version.infrared"
              ></el-progress>
              <img src="@/assets/infrared.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.infrared }}%</div>
                <div class="label">红外线阻隔率</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="version.ultraviolet"
              ></el-progress>
              <img src="@/assets/infrared.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.ultraviolet }}%</div>
                <div class="label">紫外线阻隔率</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="0"
              ></el-progress>
              <img src="@/assets/thickness.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.thickness }}mil</div>
                <div class="label">厚度</div>
              </div>
            </div>
            <div class="item">
              <el-progress
                type="circle"
                color="#45dd7d"
                define-back-color="#102a1f"
                :width="62"
                :show-text="false"
                :percentage="0"
              ></el-progress>
              <img src="@/assets/warranty.png" alt="" />
              <div class="item-wrap">
                <div class="value">{{ version.warranty }}年</div>
                <div class="label">质保年限</div>
              </div>
            </div>
          </div>
          <div class="feature-wrap">
            <div class="feature" v-for="item in series.features" :key="item.id">
              <div class="item">
                <div class="title">{{ item.title }}</div>
                <div class="desc" v-html="item.desc"></div>
                <div class="tip" v-if="item.tip">{{ item.tip }}</div>
              </div>
            </div>
          </div>
          <div class="version-wrap">
            <div
              class="version"
              v-for="v in versionList"
              :key="v.id"
              :class="{ active: version.id === v.id }"
              @click="selectVersion(v)"
            >
              {{ v.name }} <span>{{ v.range }}</span>
            </div>
          </div>
          <div class="tip">技术参数均为原厂提供测试参考值，非保证值。测量工具不同，数据略有偏差</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSeriesList } from '@/api/index'

export default {
  name: 'Home',
  data() {
    return {
      seriesList: [],
      versionList: [],
      series: {},
      version: {}
    }
  },
  created() {
    this.loadSeriesData()
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    loadSeriesData() {
      getSeriesList()
        .then((res) => {
          this.seriesList = res.data.map((item) => {
            item.features = item.features.map((f) => {
              f.desc = f.desc.replace(/\\n/g, '<br/>')
              return f
            })
            return item
          })
          const [first] = res.data
          this.series = first
          this.versionList = first.versions
          this.version = first.versions[0]
        })
        .catch((err) => {
          this.$message.error(err.msg || '加载数据失败')
        })
    },
    seriesClick(series) {
      this.series = series
      this.versionList = series.versions
      this.version = series.versions[0]
    },
    selectVersion(v) {
      this.version = v
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.first {
  height: calc(100vh - 100px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: url('~@/assets/bg_1.jpg') no-repeat center;
  background-size: cover;
  .container {
    padding: 20px;
    box-sizing: border-box;
    .company {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      & > .title {
        position: relative;
        margin: 0 0 20px 0;
        padding-bottom: 20px;
        font-size: 40px;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 100px;
          height: 6px;
          transform: translateX(-50%);
          background-color: #fff;
        }
      }
      .content {
        padding: 0 100px;
        margin: 0 0 74px 0;
        font-size: 18px;
        text-align: center;
      }
      .features-wrap {
        align-self: stretch;
        display: flex;
        justify-content: space-between;
        gap: 30px;
        padding: 30px;
        background-color: rgba($color: #102a1f, $alpha: 0.7);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        .item {
          flex: auto;
          position: relative;
          color: #fff;
          text-align: left;
          .title {
            margin-bottom: 17px;
            font-size: 22px;
            font-weight: bold;
          }
          .desc {
            font-size: 16px;
          }
          &:not(:last-child) {
            margin-right: 30px;
          }
          &:not(:last-child)::after {
            content: '';
            position: absolute;
            right: 0;
            top: 10px;
            height: 54px;
            width: 2px;
            background-color: #fff;
          }
        }
      }
    }
  }
}
.second {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  .container {
    .products {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      padding: 70px 20px;
      box-sizing: border-box;
      color: $--color-primary;
      .serise-wrap {
        flex: auto;
        display: flex;
        justify-content: space-between;
        gap: 0;
        margin-bottom: 50px;
        background-color: #a0a0a0;
        .series {
          flex: auto;
          height: 70px;
          line-height: 70px;
          font-size: 30px;
          font-weight: bold;
          color: #fff;
          text-align: center;
          cursor: pointer;
          user-select: none;
        }
        .active {
          background-color: $--color-primary;
          color: #fff;
        }
      }
      .data-wrap {
        align-self: stretch;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 50px;
        .item {
          position: relative;
          display: flex;
          align-items: center;
          gap: 18px;
          img {
            position: absolute;
            left: 15px;
            top: 15px;
            width: 32px;
            height: 32px;
          }
          .item-wrap {
            align-self: stretch;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .value {
              font-size: 28px;
              color: #333;
              font-weight: bold;
            }
            .label {
              font-size: 18px;
              color: #333;
            }
          }
        }
      }
      .feature-wrap {
        align-self: stretch;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 50px;
        .feature {
          position: relative;
          padding-left: 20px;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 6px;
            background-color: $--color-primary;
          }
          .item {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              margin-bottom: 10px;
              font-size: 22px;
              font-weight: bold;
            }
            .desc {
              font-size: 16px;
              color: #000;
              font-weight: 400;
            }
            .tip {
              margin-top: 8px;
              font-size: 14px;
              font-weight: 400;
              opacity: 0.5;
              margin-top: 8px;
            }
          }
        }
      }
      .version-wrap {
        display: flex;
        justify-content: space-between;
        gap: 30px;
        margin-top: 70px;
        .version {
          flex: auto;
          height: 70px;
          padding: 0 30px;
          border: 1px solid #aaa;
          line-height: 70px;
          font-size: 30px;
          font-weight: bold;
          color: #aaa;
          cursor: pointer;
          text-align: center;
          span {
            font-size: 16px;
          }
        }
        .active {
          color: $--color-primary;
          border-color: $--color-primary;
        }
      }

      & > .tip {
        margin: 10px;
        color: #aaa;
        text-align: center;
      }
    }
  }
}

@media screen and (max-width: 991px) {
  .first {
    height: auto;
    .container {
      flex-direction: column;
      align-items: stretch;
      .company {
        .content {
          padding: 0;
        }
        .features-wrap {
          flex-direction: column;
          padding: 20px;
          gap: 20px;
          .item {
            padding: 0;
            .title {
              margin-bottom: 10px;
            }
            &:not(:last-child) {
              margin-right: 0;
            }
            &:not(:last-child)::after {
              content: '';
              position: absolute;
              right: 0;
              top: 0;
              height: 0;
              width: 0;
            }
          }
        }
      }
    }
  }
  .second {
    .container {
      .products {
        padding: 30px 20px;
        .serise-wrap {
          margin-bottom: 30px;
          .series {
            font-size: 22px;
          }
        }
        .data-wrap {
          flex-direction: column;
          gap: 20px;
          margin-bottom: 30px;
        }
        .feature-wrap {
          grid-template-columns: repeat(1, 1fr);
          gap: 30px;
          .feature {
            margin-bottom: 20px;
          }
        }
        .version-wrap {
          margin-top: 30px;
          flex-direction: column;
          .version {
            height: 50px;
            line-height: 50px;
            font-size: 17px;
            text-align: center;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1199px) {
  .first,
  .second {
    .container {
      width: 100%;
    }
  }
  .first {
    .container {
      .company {
        .features-wrap {
          .item {
            &:not(:last-child) {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .first,
  .second {
    .container {
      width: 1200px;
    }
  }
}
</style>
